<template>
  <div v-role="'func'">
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <br>
      <v-card class="mx-auto" max-width="1200">
        <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading"
          v-show="isLoading"></v-progress-linear>
        <v-card-text>
          <v-container fluid>
            <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">{{ $store.state.textMessage }}</div>
            <v-row>
              <v-col class="d-flex" cols="12" sm="12" md="11">
                <p class="display-1 text--primary"> Consultar mensalidades pagas por Turma </p>
              </v-col>
              <v-col class="d-flex" cols="12" sm="1" md="1">
                <v-btn fab small :disabled="!estudantes_.length" @click="printDividaPdf()" color="red"><v-icon style="color:white;">print</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="text--primary">
              <v-row>
                <v-col class="d-flex" cols="12" sm="6" md="6">
                  <v-autocomplete v-model="editedItem.objecto" :items="turmas" :loading="isLoading_"
                    :search-input.sync="search" color="primary" item-text="descricao" item-value="descricao"
                    label="Descrição da turma" placeholder="Digite a descrição da turma"
                    prepend-icon="mdi-database-search" return-object @change="turmaSelecionada()"></v-autocomplete>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6" md="2">
                  <!-- <v-btn :disabled="editedItem.objecto === null "  color="#006699"  fab small   ><v-icon large color="white" >search</v-icon></v-btn> -->
                </v-col>
                <v-col class="d-flex" cols="12" sm="6" md="2">
                  <v-progress-circular v-if="progresso" indeterminate color="green"></v-progress-circular>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex" cols="12" sm="6" md="4">
                  <p>
                    <v-chip color='primary'> Curso:{{ (this.editedItem.objecto !==
                      null) ? this.editedItem.objecto.descricao : '' }}</v-chip>
                  </p>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                    <v-chip v-if="nivelEnsino === 1"> Anoacadémico: {{ (this.editedItem.objecto !==
                      null) ? this.editedItem.objecto.classe + 'º' : '' }}</v-chip>
                    <v-chip v-else> Classe: {{ (this.editedItem.objecto !==
                      null) ? this.editedItem.objecto.classe : '' }}</v-chip>
                  </p>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6" md="3">
                  <p>
                    <v-chip>Anolectivo:{{ (this.editedItem.objecto !==
                      null) ? this.editedItem.objecto.anolectivo : '' }}</v-chip>
                  </p>
                </v-col>


              </v-row>
              <v-row>
                <v-col class="d-flex" cols="12" sm="6" md="12">

                  <template>
                    <v-card width="1200">
                      <v-toolbar color="#006699" dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>

                        <v-toolbar-title>Resultado da pesquisa</v-toolbar-title>

                        <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-card-text>
                        <v-row>
                          <v-col md="12">


                            <v-data-table :headers="headers" :items="estudantes_" :search="searchInDb" sort-by="data_"
                              class="elevation-3">
                              <template v-slot:top>
                                <v-toolbar flat color="white">
                                  <div class="flex-grow-1"></div>
                                  <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
                                    <v-icon>cached</v-icon>
                                  </v-btn>
                                  <v-text-field v-model="searchInDb" append-icon="search" label="Pesquisa" single-line
                                    hide-details></v-text-field>
                                  <!-- end  search  -->
                                </v-toolbar>
                              </template>

                              <template v-slot:no-data>
                                <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
                                Clica em + para adicionar novo estudante
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </template>

                </v-col>

              </v-row>

            </div>

            <template>
              <v-row>
                <v-col md="4">
                  <span style="margin-left:54px;font-size:18px;font-weight:bold;">Nº de estudantes:
                    <v-chip>{{ estudantes_.length }}</v-chip></span>
                </v-col>
                <v-col md="4">
                </v-col>
                <v-col md="4">
                  <span>Valor Total: <v-chip color="#006699" style="color:white;">{{ formatMoney(totalPropina) }}
                    </v-chip></span>
                </v-col>
              </v-row>
            </template>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import axiosFinancas from '../../plugins/axiosFinancas'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2';
const ls = require('local-storage')

export default {
  data: () => ({
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    estudantes: [],
    estudantes_: [],
    turmasAll: [],
    listaDeClassesPorLancarNotas: [],
    turmasFiltered: [],
    precoMulta: [],
    searchInDb: '',
    valid: true,
    overlay: false,
    jaMatriculado: '',
    classe: '',
    detalhe: '',
    disabled: false,
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    acesso: [],
    totalPropina: 0,
    multaTotal: 0,
    classesFiltered: [],
    descriptionLimit: 60,
    entries: [],
    classes: [],
    mesesEmFalta: [],
    multas: [],
    multasFiltered: [],
    turmas: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null,
      classe: null
    },
    defaultItem: {
      objecto: null,
      Turma: null,
      classe: null
    },
    ruleRequired: [value => value || 'campo obrigatorio'],
    headers: [
      {
        text: 'Estudante',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Matrícula', value: 'idMatricula' },
      { text: 'Meses', value: 'meses' },
      { text: 'Valor Pago', value: 'multas' },

    ],
  }),

  computed: {

    nivelEnsino() { // 1-  Ensino superior,  2- ensino Médio
      return ls.get('nivel')
    },

    ListaActividades() {
      return ls.get('lista_actividades')
    },
    mesesPrazo() {
      return ls.get('meses')
    },
    fields() {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search(val) {
      // Items have already been loaded
      // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 1) {
        // Items have already been requested
        if (!this.turmas.filter(t => t.descricao.includes(val)).length) {
          this.turmas = []
        }
        return this.initializeTurmas(val)
      }
    }

  },
  created() { },

  methods: {

    printDividaPdf() {
      try {
        this.overlay = true;
        this.$store.state.loading_pdf = true;
        ls.set('estudantes_', this.estudantes_)
        ls.set('turma', this.editedItem.objecto)
        ls.set('total', this.totalPropina)

        /*
          Esse trecho de código, imprimirRecibo(), carrega dinamicamente o componente de 
          uma segunda página chamada "recibo-pagamento-escola.vue" e o monta em uma instância 
          temporária do Vue. Isso permite que você exiba e imprima um recibo de pagamento da 
          escola sem interferir na página atual.
        */

        import('./report-mensalidadespagas.vue').then((module) => {
          const SegundaPagina = module.default;
          const tempInstance = new Vue({
            render: (h) => h(SegundaPagina),
          });
          tempInstance.$mount();
        })

      } catch (error) {
        this.$store.state.loading_pdf = false;
        Swal.fire('Informação', 'Ocorreu um erro durante a impressão do documento!', 'warning');
      } finally {
        this.overlay = false;
      }
    },

    formatMoney(value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    async initializeTurmas(payload) {
      try {
        this.isLoading = true
        this.turmas = await axiosFinancas
          .post('/turmasFindAllsearchBy', { descricao: payload })
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async turmaSelecionada() {
      try {
        this.overlay = true
        this.estudantes = await axiosFinancas
          .get('/estudantesFindAllByTurma/' + this.editedItem.objecto.id)
          .then(res => res.data)
        if (this.estudantes.length) {
          this.verificaMensalidadesPagas().then(res => {
            setTimeout(() => {
              this.estudantes_ = this.estudantes
              this.overlay = false
            }, 1000);

          })
        } else {
          this.overlay = false
          this.text = 'Turma vazia'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }

      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async verificaMensalidadesPagas() {
      this.estudantes.forEach(async element => {
        let index_ = this.estudantes.indexOf(element)
        let mesesPagos = await this.MensalidadesPagasPorEstudante(element.bi.replaceAll('-', ''))
        if (mesesPagos) {
          this.estudantes[index_].meses = mesesPagos[0].meses
          this.estudantes[index_].multas = utilitarios.IntegerToMoneyValueFatura(mesesPagos[0].propina)
          this.totalPropina += mesesPagos[0].propina
        } else {
          this.overlay = false
          this.estudantes[index_].meses = 'Nenhuma mensalidade Paga.'
          this.estudantes[index_].multas = '0,00 '
          this.totalPropina += 0
        }


      });
    },



    async MensalidadesPagasPorEstudante(estudanreId) {
      try {
        return await axios
          .get('/mensalidadesPagasByEstudanteGroupByIdCliente/' + estudanreId)
          .then(res => res.data)

      } catch (error) {
        this.isLoading = false
      }
    },


  }
}
</script>
